import classNames from "classnames";

type LoadingIconProps = {
  className?: string;
};

export const LoadingIcon = ({ className }: LoadingIconProps) => {
  return (
    <span
      className={classNames(
        "loading loading-infinity bg-primary",
        className
      )}
    ></span>
  );
};